const FEATURE_KEYS = {
    cptReporting: 'CPTReporting',
    guestAccess: 'GuestAccess',
};

export default FEATURE_KEYS;
